export default "__VITE_ASSET__N23BE_5Q__"